import {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import './FullScreen.css';

const prefix = "FullScreen";

const FullScreen = class extends Component {
	static propTypes = {
		className: PropTypes.string,
		style: PropTypes.object,
		backdrop: PropTypes.bool,
		toggle: PropTypes.func,
	}
	render() {
		return ReactDOM.createPortal(
			<div
				className={`${prefix}OuterContainer`+(this.props.className ? ' '+this.props.className : '')}
				style={this.props.style}
				onClick={ e => {
					e.stopPropagation();
					if ( ! this.props.backdrop && typeof this.props.toggle === 'function' ) this.props.toggle();
				}}
			>
				<div
					className={`${prefix}InnerContainer`}
					onClick={ e => e.stopPropagation() }
					onDoubleClick={ e => e.stopPropagation() }
					onFocus={ e => e.stopPropagation() }
				>
					{ this.props.children }
				</div>
			</div>,
			window.document.body
		)
	}
}

export default FullScreen;
